export default __webpack_public_path__ + "static/media/CNo.60-2.f68728a8.jpg";